import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import UserDto from "../classes/dtos/accountmodule/UserDto";
import CustomerApiCredentialListDto from "../classes/dtos/credentialmodule/CustomerApiCredentialListDto";
import EnsurePersonalAccessTokenResult from "../classes/api/result/credentialmodule/EnsurePersonalAccessTokenResult";

const CustomerApiCredentialApi = {

    GetCustomerApiCredentialsAsync: async function (): Promise<ProcessingResult<CustomerApiCredentialListDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerApiCredential/GetCustomerApiCredentials", {
            method: "Get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.customerApiCredentials.map((e: { id: number; createdBy: any, validityStart: Date; validityEnd: Date | null; name: string; type: number; }) => new CustomerApiCredentialListDto(e.id, new UserDto(e.createdBy.id, e.createdBy.email, e.createdBy.firstName, e.createdBy.lastName), e.validityStart, e.validityEnd, e.name, e.type)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateCustomerApiCredentialsAsync: async function (validityStart: Date, validityEnd: Date | null, name: string): Promise<ProcessingResult<number>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerApiCredential/CreatePersonalAccessToken", {
            method: "POST",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'validityStart': validityStart,
                'validityEnd': validityEnd,
                'name': name
            })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.id);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    UpdateCustomerApiCredentialsAsync: async function (id: number, validityStart: Date, validityEnd: Date | null, name: string): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerApiCredential/UpdatePersonalAccessToken", {
            method: "PUT",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({
                'id': id,
                'validityStart': validityStart,
                'validityEnd': validityEnd,
                'name': name
            })
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    DeleteCustomerApiCredentialsAsync: async function (id: number): Promise<ProcessingResult<boolean>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerApiCredential/DeletePersonalAccessToken?id=" + id, {
            method: "DELETE",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            return ProcessingResult.Ok(true);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetPersonalAccessTokenAsync: async function (id: number): Promise<ProcessingResult<string>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerApiCredential/GetPersonalAccessToken?id=" + id, {
            method: "GET",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.personalAccessToken);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    EnsurePersonalAccessTokenAsync: async function (pathId: number): Promise<ProcessingResult<EnsurePersonalAccessTokenResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/CustomerApiCredential/EnsurePersonalAccessToken?pathId=" + pathId, {
            method: "Post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: ""
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new EnsurePersonalAccessTokenResult(data.personalAccessToken));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default CustomerApiCredentialApi;